module["exports"] = [
  "المملكة العربية السعودية"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ar/address/default_country.js
// module id = 2381
// module chunks = 1610